import { render } from "./BaseGuestsPill.vue?vue&type=template&id=70ad56be&scoped=true"
import script from "./BaseGuestsPill.vue?vue&type=script&lang=js"
export * from "./BaseGuestsPill.vue?vue&type=script&lang=js"

import "./BaseGuestsPill.vue?vue&type=style&index=0&id=70ad56be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ad56be"]])

export default __exports__